import React from 'react';

const Rupee = ({ fill = '' }: { fill?: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM5.39844 5.97613V4.32812H13.0784V5.40013H10.4704C11.0464 5.83213 11.4144 6.44013 11.5424 7.12813H13.0784V8.20013H11.5584C11.3664 9.75213 10.2304 10.6161 9.06244 10.8081L11.6704 15.0001H9.51044L7.14244 11.0161H5.39844V9.36813H7.84644C8.69444 9.36813 9.35044 8.92013 9.59044 8.20013H5.39844V7.12813H9.60644C9.39844 6.39213 8.72644 5.97613 7.84644 5.97613H5.39844Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

export default Rupee;
